import { render } from "./MessageIcon.vue?vue&type=template&id=30f8e91e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/MessageIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30f8e91e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30f8e91e', __exports__)) {
    api.reload('30f8e91e', __exports__)
  }
  
  module.hot.accept("./MessageIcon.vue?vue&type=template&id=30f8e91e", () => {
    api.rerender('30f8e91e', render)
  })

}


export default __exports__